import React, { useState } from "react";
import styled from "styled-components";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import EditBtn from "../../../component/atoms/button/editBtn";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import moment from "moment";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import ReviewApi from "../../../api/review.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";

function ReviewModal({ data, setData, list, setList, setModalOpen }) {
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const setMainFlagFunc = async () => {
    try {
      if (data.mainFlag) {
        await ReviewApi.updateMainFlagFalse(data.id);
      } else {
        const ids = [data.id];

        await ReviewApi.updateMainFlagTrue({ ids });
      }
      toast(toastMsg.update);
      setSaveModalOpen(false);
      setData({ ...data, mainFlag: !data.mainFlag });
      setList(list.map((item) => (item.id === data.id ? { ...item, mainFlag: !data.mainFlag } : item)));
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <ModalWrapper>
      <ModalBox>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "30px",
          }}
        >
          <TableTitle style={{ marginBottom: "0px" }}>수강후기 상세</TableTitle>
          <img
            style={{
              cursor: "pointer",
            }}
            src="/assets/admin/icons/ico_popup_close.svg"
            alt=""
            onClick={() => setModalOpen(false)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            minHeight: "223px",
            overflowY: "auto",
          }}
        >
          <DetailPageForm>
            <DetailFormTitle>아이디</DetailFormTitle>
            <DetailFormText>{data.member?.account}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm>
            <DetailFormTitle>이름</DetailFormTitle>
            <DetailFormText>{data.member?.name}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm>
            <DetailFormTitle>작성일</DetailFormTitle>
            <DetailFormText>{moment(data.createdAt).format("YYYY/MM/DD")}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm>
            <DetailFormTitle>별점</DetailFormTitle>
            <DetailFormText>{data.score}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm>
            <DetailFormTitle>제목</DetailFormTitle>
            <DetailFormText>{data.title}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm style={{ alignItems: "flex-start" }}>
            <DetailFormTitle>내용</DetailFormTitle>
            <DetailFormText>{data.content}</DetailFormText>
          </DetailPageForm>
          <div style={{ paddingTop: "10px" }}>
            <SaveBtn
              text={data.mainFlag ? "대표 해제" : "대표 등록"}
              onClick={() => {
                setSaveModalOpen(true);
              }}
            />
          </div>
        </div>
      </ModalBox>

      {saveModalOpen ? (
        <Modal
          title={data.mainFlag ? "대표 해제하시겠습니까?" : "대표로 설정하시겠습니까?"}
          text={
            data.mainFlag ? undefined : (
              <>
                대표 후기는 메인페이지에 노출되며,
                <br />
                금융 스터디와 유료 강의를 통합하여
                <br />
                최대 6개까지 지정 가능합니다.
              </>
            )
          }
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            setMainFlagFunc();
          }}
        />
      ) : null}
    </ModalWrapper>
  );
}

export default ReviewModal;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 30;
`;

const ModalBox = styled.div.attrs((props) => {})`
  width: 1064px;
  min-height: 328px;
  max-height: 700px;
  overflow: auto;
  padding: 50px;
  border: 1px solid #d7dbe0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  /* 스크롤바 스타일 */
  &::-webkit-scrollbar {
    width: 17px; /* 스크롤바 너비 */
  }

  &::-webkit-scrollbar-track {
    background: #fff; /* 스크롤바 트랙 배경색 */
    border-radius: 10px; /* 스크롤바 트랙 둥근 모서리 */
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바 색상 */
    border: 7px solid #fff;
    border-radius: 10px; /* 스크롤바 둥근 모서리 */
  }
`;
